import { useTranslation } from 'react-i18next';
import type { AssistantToolActivity } from '@/api/assistant/assistantApi.types';
import { Icon } from '@/components/common/Icon';
import { cn } from '@/lib/utils';

interface AssistantActivityListProps {
  activities: AssistantToolActivity[];
}

export function AssistantActivityList({ activities }: AssistantActivityListProps) {
  const { t } = useTranslation('assistant');
  if (activities.length === 0) {
    return null;
  }
  return (
    <ul className="space-y-1.5 mb-2.5" aria-label={t('activity.listLabel')}>
      {activities.map(function renderActivity(activity) {
        const isRunning = activity.status === 'started';
        return (
          <li
            key={activity.callId}
            className={cn(
              'flex items-center gap-2 text-xs',
              isRunning ? 'text-zooprimary' : 'text-zoomuted'
            )}
          >
            {isRunning ? (
              <span className="w-3.5 h-3.5 rounded-full border-2 border-zoopalelavender border-t-zooprimary motion-safe:animate-spin shrink-0" />
            ) : (
              <Icon name="CheckCircle" className="text-zoosuccesstext shrink-0" />
            )}
            <span>
              {t('activity.' + activity.activityKey, { defaultValue: t('activity.working') })}
            </span>
          </li>
        );
      })}
    </ul>
  );
}
